import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { api } from '../composables/api';
import { baseURL } from "../composables/const";

export const useContractsStore = defineStore("contracts", () => {
  const contractStep = ref('two')
  const champion = ref({
    durationTerm: '1M', 
    startDate: '',
    endDate: '',
    chosenSports: [],
    sumStep: '300000',
  })
  const price = ref(0)

  const dateRange = computed(() => {
    const d1 = champion.value.startDate.split('-').join('.')
    const d2 = champion.value.endDate.split('-').join('.')
    return (new Date(d2).getTime() - new Date(d1).getTime()) / (24 * 60 * 60 * 1000) + 1
  })

  async function getSports(data) {                  // виды спорта для чемпиона
    const arr = []
    const res = await api.post(baseURL, data);
    for (let key in res.data.kinds_of_sports_list) {
      arr.push({id: key, text: res.data.kinds_of_sports_list[key]})
    }
    return arr
  }

  async function getCalculation(data) {             // на самом деле метод на бек всего 1, а его разновидность определяется объектом data,
    return await api.post(baseURL, data)            // в особенности полями action и agreement
  }

  return {
    contractStep,
    champion,
    price,
    dateRange,
    getSports,
    getCalculation,
  };
});
